module.exports = __webpack_public_path__ + "img/banner_a.3d772139.png";